function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24054"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17742",
    d: "M4.115 6.115a3.808 3.808 0 0 0 0 5.385l6.5 6.5 6.5-6.5a3.808 3.808 0 0 0-5.385-5.385L10.615 7.23 9.5 6.115a3.808 3.808 0 0 0-5.385 0z",
    transform: "translate(1.2 .4)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgHeart;